import Header from './header'
import Navigation from './navigation'
import Theme from './theme'
import style from './style.module.css'
import { ReactComponent as InspireBg } from 'assets/icon-inspire-bg.svg'

const Layout = ({ event, children }) => {

    return (
        <>
            <div className={style.layout}>
                {event.backgroundUrl ? (
                    <img src={event.backgroundUrl} alt='' className='position-fixed z-n1 h-100 w-100' style={{ top: 0, left: 0, right: 0, bottom: 0, objectFit: 'cover', objectPosition: 'center' }} />
                ) : (
                    <InspireBg className={'position-fixed z-n1 '} style={{ top: '50%', left: '50%', width: 'max(100vw, 100vh)', height: 'max(100vw, 100vh)', transformOrigin: 'center', transform: 'translate(-50%, -50%) scale(1.1)'}} />
                )}
                <Header event={event} />
                <Navigation event={event} />
                <div className={style.content + ' event-content-area'}>
                    {children}
                </div>
            </div>
            <Theme event={event} />
        </>
    )

}

export default Layout